import React from 'react';
import { Sparkles } from 'lucide-react';
import { AssistantChat, NAVY, GREEN } from '@/components/AssistantChat';

/**
 * DRAWREADY ASSISTANT — full-page visual mockup / preview.
 * Interactive front-end-only prototype (no AI wired yet). Route: /assistant-preview
 */
export default function AssistantPreview() {
  return (
    <div className="min-h-screen bg-slate-100" data-testid="assistant-preview">
      <div className="bg-amber-50 border-b border-amber-200 text-amber-800 text-xs text-center py-1.5 font-medium">
        Preview mockup · UI only · no real actions are performed yet
      </div>
      <div className="max-w-2xl mx-auto px-4 py-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-11 h-11 rounded-2xl flex items-center justify-center text-white shadow" style={{ background: NAVY }}>
            <Sparkles className="w-6 h-6" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-slate-900">DrawReady Assistant</h1>
            <p className="text-sm text-slate-500">Ask anything, or tell me what to do.</p>
          </div>
          <span className="ml-auto text-[11px] font-semibold px-2.5 py-1 rounded-full text-white" style={{ background: GREEN }}>Powered by Claude</span>
        </div>
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden flex flex-col" style={{ height: '68vh' }}>
          <AssistantChat heightClass="flex-1" showExamples showFootnote />
        </div>
      </div>
    </div>
  );
}
